import styled from 'styled-components';

export const PanelPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;


`